import React from 'react';
import { NavLink as NL, useNavigate } from 'react-router-dom';

export function NavLink(props: {
  to: string;
  id?: string;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  'aria-label'?: string;
  onClick?: (t: any) => void;
}) {
  const { to, id, className = '', children, onClick } = props;
  const navigate = useNavigate();
  return (
    <NL
      data-testid={id}
      id={id}
      aria-label={props['aria-label']}
      to={to}
      className={className}
      onClick={e => {
        if (props.disabled) {
          e.preventDefault();
          return;
        }
        if (e.metaKey || e.ctrlKey) {
          return;
        }
        e.preventDefault();
        const {
          location: { protocol, host },
        } = window;
        if (onClick) {
          onClick(e);
        }
        const baseUrl = `${protocol}//${host}`;
        if ((window as any).swUpdate) {
          window.location.href = `${baseUrl}${to}`;
          return;
        }
        navigate(to);
      }}
    >
      {children}
    </NL>
  );
}
